// Dados de produtos para o simulador da experiência PlayMenu.
// Os vídeos devem ser colocados em /public/videos/ (substitua quando tiver os arquivos oficiais).

export interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  category: string;
  image: string;
  video: string;
}

export const products: Product[] = [
  {
    id: "smash-bacon",
    name: "Smash Bacon",
    description: "Pão brioche, blend artesanal, queijo cheddar derretido e bacon crocante.",
    price: "R$ 34,90",
    category: "Burgers",
    image:
      "https://readdy.ai/api/search-image?query=Appetizing%20smash%20bacon%20cheeseburger%20with%20melted%20cheddar%20cheese%20dripping%20down%20the%20sides%20caramelized%20onions%20and%20crispy%20bacon%20on%20a%20dark%20charcoal%20slate%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20atmosphere%20shallow%20depth%20of%20field%20high%20detail%20subtle%20steam%20rising&width=720&height=1280&seq=playmenu-burger-01&orientation=portrait",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/31907eb5-760e-43dd-b87f-926fcd2aab4a_Hamburguer_chedar_e_cebola_caram_20260916164117.mp4",
  },
  {
    id: "pizza-burrata",
    name: "Pizza portuguesa",
    description: "Massa de fermentação lenta, burrata cremosa e manjericão fresco.",
    price: "R$ 59,90",
    category: "Pizzas",
    image:
      "https://readdy.ai/api/search-image?query=Artisan%20burrata%20pizza%20with%20stretchy%20melted%20cheese%20pull%20fresh%20basil%20leaves%20and%20blistered%20crust%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20atmosphere%20shallow%20depth%20of%20field%20high%20detail&width=720&height=1280&seq=playmenu-pizza-01&orientation=portrait",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/eb96f317-46ba-4adc-853d-558572e18d43_vdeo_20260916162917.mp4",
  },
  {
    id: "camarao-crocante",
    name: "Camarão à Parmegiana",
    description: "Camarões empanados, molho da casa e toque de limão siciliano.",
    price: "R$ 48,00",
    category: "Entradas",
    image:
      "https://readdy.ai/api/search-image?query=Crispy%20golden%20fried%20shrimp%20with%20creamy%20dipping%20sauce%20and%20fresh%20lime%20wedges%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20atmosphere%20shallow%20depth%20of%20field%20high%20detail&width=720&height=1280&seq=playmenu-shrimp-01&orientation=portrait",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/285ece75-34c9-43ac-aa25-1a3026f57df6_Camacao_a_parmegiana_dish_202608140613.mp4",
  },
  {
    id: "pudim",
    name: "Pudim",
    description: "Pudim de leite condensado com calda de caramelo brilhante.",
    price: "R$ 26,90",
    category: "Sobremesas",
    image:
      "https://readdy.ai/api/search-image?query=Brazilian%20pudim%20de%20leite%20condensado%20creamy%20flan%20slice%20with%20glossy%20golden%20caramel%20sauce%20dripping%20down%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20atmosphere%20shallow%20depth%20of%20field%20high%20detail&width=720&height=1280&seq=playmenu-pudim-01&orientation=portrait",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/6fc646a1-60fd-466c-85f1-dd0b501b02ed_Analyze_food_image_for_commercial_202606170127.mp4",
  },
  {
    id: "caipirinha",
    name: "Caipirinha",
    description: "Cachaça artesanal, limão taiti, açúcar e muito gelo.",
    price: "R$ 24,90",
    category: "Drinks",
    image:
      "https://readdy.ai/api/search-image?query=Refreshing%20Brazilian%20caipirinha%20cocktail%20with%20muddled%20lime%20wedges%20sugar%20and%20crushed%20ice%20in%20a%20short%20glass%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20drink%20photography%20cinematic%20moody%20atmosphere%20shallow%20depth%20of%20field%20high%20detail&width=720&height=1280&seq=playmenu-caipirinha-01&orientation=portrait",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/680df7a4-b8da-490c-aa2c-2ce79964409f_c75dea2d101c485491e0b1f923d12a80.mp4",
  },
];

export const categories = [
  "Todos",
  "Burgers",
  "Pizzas",
  "Entradas",
  "Sobremesas",
  "Drinks",
];